const AceHWStatusNotificationApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/status-notification/get`,
  POST: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/status-notification/create`,
  PUT: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/status-notification/update`,
  DELETE: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/status-notification/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/status-notification/download`
}
 
export default AceHWStatusNotificationApiUrls
